<template>
    <SparkListItem
        :end-item="!large && item.image ? 'image' : null"
        :end-image="item.image"
        :subtext="formattedDate"
        :class="{ 'cursor-pointer': item.link }"
        :bottom-divider="!isLast ? 'full' : null"
        @click="onClick"
    >
        <template
            v-if="large && item.image"
            #feature-top
        >
            <UIImage
                :src="item.image"
                :alt="item.title"
                class="mb-4"
            />
        </template>
        <template #eyebrow>
            <SparkListItemEyebrowIconText
                v-if="item.category"
                :icon="item.category.icon"
                :html="item.category.title"
            />
        </template>
        <template
            v-if="item.title"
            #title
        >
            <UIHtml
                :html="item.title"
                class="prose leading-5 text-[length:inherit] text-inherit"
                style="overflow-wrap: anywhere;"
            />
        </template>
        <template
            v-if="item.body"
            #description
        >
            <div
                class="content-sm-ux-regular mb"
                :class="{
                    'line-clamp-3': large,
                    'line-clamp-1': !large,
                }"
            >
                <UIHtml
                    :html="item.body"
                    class="prose leading-5 text-[length:inherit] text-inherit"
                    style="overflow-wrap: anywhere;"
                />
            </div>
        </template>
    </SparkListItem>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import dayjs from '@/dayjs'
    import UIHtml from '@/components/ui/UIHtml.vue'
    import UIImage from '@/components/ui/UIImage.vue'
    import SparkListItem from '@/components/ui/SparkListItem.vue'
    import SparkListItemEyebrowIconText
        from '@/components/ui/SparkListItem/SparkListItemEyebrowIconText.vue'
    import { useDateHelper } from '@/composables/useDateHelper'

    const props = defineProps({
        item: Object,
        large: Boolean,
        isLast: Boolean,
    })
    const router = useRouter()

    const moduleHelpers = useModuleHelpers()

    const dateHelper = useDateHelper()

    const clicking = ref(false)

    const formattedDate = computed(() => {
        return dateHelper.value.formatDateRelative(dayjs(props.item.date))
    })

    const onClick = () => {
        if (clicking.value || !props.item.link) {
            return
        }

        clicking.value = true
        moduleHelpers.openModuleOrOpenBrowserForLinkData(router, props.item.link)
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                clicking.value = false
            })
    }
</script>
